import { type LogEntry } from '@/lib/types';
import CoachCommentsContext from '../../../CoachComments/CoachCommentsContext';
import PortfolioItemContext from '../../../../../PortfolioItemContext';
import { useContext } from 'react';
import CoachComments from '../../../CoachComments';

type LogEntryCoachCommentsProps = {
  logEntry: LogEntry;
};

const LogEntryCoachComments = ({ logEntry }: LogEntryCoachCommentsProps) => {
  const { portfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  return (
    <CoachCommentsContext.Provider
      value={{
        coachComments: Object.values(portfolioItem.coachComments).filter(
          coachComment => coachComment.logEntryId === logEntry.id,
        ),
        addCoachCommentApiUrl: `${portfolioItemApiEndpoint}/coach-comments/log-entry?logEntryId=${logEntry.id}`,
        isInLogEntry: true,
      }}
    >
      <CoachComments />
    </CoachCommentsContext.Provider>
  );
};

export default LogEntryCoachComments;
